import AddressDTO from "@/dto/AddressDTO";

export class CreateST120Member {
    public email: string | null = null;
    public name: string | null = null;
    public companyId: number | null = null;
}

export class ST120Memer {
    public readonly name!: string;
    public readonly email!: string
    public address: AddressDTO | null = null;
}

export enum PurchaseType {
    MATERIAL = "MATERIAL",
    SERVICE = "SERVICE",
    FOOD = "FOOD",
    STATE_RESALE = "STATE_RESALE",
    COUNTRY_RESALE = "COUNTRY_RESALE"
}

export class CreateSt120Payload {
    public seller: CreateST120Member = new CreateST120Member();
    public purchaserId: number | null = null;
}

export class ST120FillingData {
    public seller: ST120Memer = new ST120Memer();
    public purchaser: ST120Memer = new ST120Memer();
    public foreignPurchaser = false;
}

export default class FillSt120Payload {
    public seller: ST120Memer = new ST120Memer();
    public purchaser: ST120Memer = new ST120Memer();
    public singleCert = false;
    public opportunityTypes: string | null = null;
    public products: string | null = null;
    public hasCoA = false;
    public nyVendor: boolean | null = null;
    public coa: string | null = null;
    public coaExpirationDate: string | null = null;
    public purchases: PurchaseType[] | null = null;
    public foreignPurchaser = false;
    public placeOfTaxAdministration: string | null = null;
    public foreignNumber: string | null = null;
    public officerName = "";
    public signingDate: string | null = null;

    constructor(init?: Partial<FillSt120Payload>) {
        Object.assign(this, init)
        if (this.purchaser.address == null) {
            this.purchaser.address = new AddressDTO();
        }
        if (this.seller.address == null) {
            this.seller.address = new AddressDTO();
        }
    }
}

